import { render, staticRenderFns } from "./NewPasswordView.vue?vue&type=template&id=276c0658&"
import script from "./NewPasswordView.vue?vue&type=script&lang=js&"
export * from "./NewPasswordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports